export default {
    data() {
        return {
            // 搜索表单数据
            form: {
                // 项目名称
                category_name: '',
                // 课程类型
                course_type: '',
                // 备注
                note: '',
                // 所属年度
                year: '',
                // 专业
                profession: ''
            },
            // 年度数据
            years: [],
            // 专业数据
            professionalList: [
                {
                    label: '专业课',
                    value: '专业课',
                },
                {
                    label: '选修课',
                    value: '选修课',
                }
            ],
            // 表格数据
            tableData: [],
            // 总条数
            total: 20,
            // 当前页
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 已选择的表格行
            selections: [],
            // 已选择的表格行的id
            selectionIds: [],
            // 查看详细对话框
            showDetailDialog: false,
            // 详细内容表单数据
            detailForm: {
                // 项目名称
                projectName: '',
                // 专业
                professional: '',
                // 年度
                year: '',
                // 课程类型
                courseType: '',
                // 总学时
                period: '',
                // 总价
                price: '',
                // 所属课程
                courses: [],
            },
            // 已选择的需要删除的表格行的id
            deleteIds: [],
			//单行信息
            infoData:{},
            // 课程包名称数组
            coursePackList: [],
        }
    },
    methods: {
        // 搜索
        search() {
            console.log(this.form);
			this.currentPage = 1 
			this.getData()
        },

        // 当选择项发生变化时会触发该事件
        handleSelectionChange(selections) {
			this.infoData = selections[0]
			
            this.selections = selections;
            // 取出选择的表格行的id
            this.selectionIds = selections.map(item => item.id);
        },

        // 点击查看详细按钮
        showDetail() {
            // 先判断是否有选择记录且只选择一条记录
            if (this.selectionIds.length === 0 || this.selectionIds.length > 1) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }

            this.showDetailDialog = true;
			console.log(this.infoData)
			this.$post('product_category/categoryProductDetail',{
				token:this.$store.state.authority_management,
				category_id:this.infoData.category_id
			}).then(res=>{
				console.log(res)
				this.detailForm = res.data.result
			})

            // 发送请求获取数据
            
        },

        // 当选择项发生变化时会触发该事件，查看详情的列表
        handleSelectionChange2(selections) {
			console.log(selections)
            // 取出选择的表格行的id
            this.deleteIds = selections.map(item => item.id);
        },

        // 点击删除课程按钮
        deleteCourse() {
            // 先判断是否有选择记录
            if (this.deleteIds.length === 0) {
                this.$message.warning('抱歉！请选择一条记录！');
                return;
            }
			
            // 删除
			this.$post('product_category_mapping/delete',{
				token:this.$store.state.authority_management,
				ids:JSON.stringify(this.deleteIds)
			}).then(res=>{
				this.$message.success('删除成功！');
			})
            
        },

        // 每页显示条数改变时调用
        handleSizeChange(pageSize) {
			this.currentPage = 1
            this.pageSize = pageSize;
			this.getData()
        },

        // 当前页改变时调用
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
			this.getData()
        },
		getData(){
			this.$post('product_category/categorySearch',{
				token: this.$store.state.authority_management,
				offset:(this.currentPage - 1) *this.pageSize,
				length:this.pageSize,
				category_name:this.form.category_name,
				profession:this.form.profession,
				course_type:this.form.course_type,
				year:this.form.year,
				note:this.form.note
			}).then(res=>{
				this.tableData = res.data.result.result
				this.total = res.data.result.total
			})
        },
        
        // 获取课程包年度
        getCoursePackageYears() {
            this.$post('product_category/get_year', {
                available: 1,
                offset: 0,
                length: 999
            }).then(res => {
                this.years = res.data.result.data;
            });
        },

        // 获取课程包数据
        getCoursePackageData() {
            this.$post('product_category/categoryList', {
                token: this.$store.state.authority_management,
                offset: 0,
                length: 99999
            }).then(res => {
				this.coursePackList = res.data.result;
            })
        }
    },
	created(){
        this.getData();
        this.getCoursePackageYears();
        this.getCoursePackageData();
	}
}